// Module
var code = "<p class=\"circle\">1</p> <p><a href=\"/makePayment\" target=\"_blank\">Sign in to Account Access.</a></p> ";
// Exports
export default code;